import { tv } from "tailwind-variants";

const spinnerVariants = tv({
  base: "size-12 animate-spin rounded-full border-4 border-line border-t-line-inverted",
});

type SpinnerProps = {
  className?: string;
};

export const Spinner = ({ className }: SpinnerProps) => {
  return <div className={spinnerVariants({ className })} />;
};
